import { ChangeDetectorRef, Injectable, OnDestroy } from '@angular/core';
import { VIEW_GROUP_VECTOR_STORAGE_KEY } from './view-group.constants';

const BROWSER_WINDOW = window;
const BROWSER_STORAGE = localStorage;
const SCHEDULE_ACTION = setTimeout;

@Injectable()
export class ViewGroupPlatform implements OnDestroy {
	constructor(private changeDetector: ChangeDetectorRef) {}

	viewportWidth(): number {
		return BROWSER_WINDOW.innerWidth;
	}

	bindResize(handler: () => void): void {
		BROWSER_WINDOW.onresize = handler;
	}

	refreshView(): void {
		this.changeDetector.detectChanges();
	}

	schedule(action: () => void, delay: number): void {
		SCHEDULE_ACTION(action, delay);
	}

	readVectorData(): Object[] {
		return JSON.parse(BROWSER_STORAGE.getItem(VIEW_GROUP_VECTOR_STORAGE_KEY));
	}

	reloadPage(): void {
		BROWSER_WINDOW.location.reload();
	}

	ngOnDestroy(): void {
		BROWSER_WINDOW.onresize = null;
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group.platform.ts